The postal code of the address.
